import React from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'
import { dark } from 'toonswap-uikit'

const BUTTON_BG = '#fe7b2a'
const BUTTON_DISABLED_BG = '#747f81'

// Settings (and other) modal theme: dark card to match swap/menu
const modalTheme = {
  background: '#475355',
  border: '4px solid #252c2d',
  borderRadius: '40px',
}

// Card/CardBody theme: dark card background to match app
const cardTheme = {
  ...dark.card,
  background: '#374244',
  cardHeaderBackground: '#374244',
  boxShadow: '0px 2px 12px -8px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.05)',
}

// Primary Button theme: match Connect Wallet button (orange accent)
const colorsWithButton = {
  ...dark.colors,
  button: BUTTON_BG,
  backgroundDisabled: BUTTON_DISABLED_BG,
  textDisabled: '#ffffff',
}

const darkWithModal = {
  ...dark,
  colors: colorsWithButton,
  modal: { ...dark.modal, ...modalTheme },
  card: cardTheme,
}

const ThemeContext = React.createContext({ isDark: true, toggleTheme: () => null })

const ThemeContextProvider = ({ children }) => {
  // Dark mode only: always use dark theme, no light mode
  const isDark = true
  const toggleTheme = () => undefined // dark mode only, no-op

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <SCThemeProvider theme={darkWithModal}>{children}</SCThemeProvider>
    </ThemeContext.Provider>
  )
}

export { ThemeContext, ThemeContextProvider }
